"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Wrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: relative;\n    transition-property: all;\n    border: 0 none;\n    outline: 0 none;\n    background: transparent;\n    padding: 0;\n    margin: 0;\n    display: block;\n    user-select: none;\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n    &:hover {\n        ", ";\n    }\n    &:active {\n        ", ";\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        &:before {\n            display: block;\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 100%;\n            width: 100%;\n            transition-property: all;\n            ", ";\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var base = function base(_ref) {
  var theme = _ref.theme,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled;
  var palette = theme.palette;
  return {
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    cursor: disabled ? 'not-allowed' : theme.cursor,
    width: width + 'px',
    height: height + 'px',
    '&:hover:before': theme.hoverRippleFx,
    '&:active:before': theme.activeRippleFx
  };
};

var ripple = function ripple(_ref2) {
  var theme = _ref2.theme,
      rippleColor = _ref2.rippleColor;
  var palette = theme.palette;

  var styles = _objectSpread({
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    background: rippleColor,
    borderRadius: theme.rippleBorderRadius
  }, theme.idleRippleFx);

  return (0, _styledComponents.css)(_templateObject(), styles);
};

var fx = (0, _styledComponents.css)(_templateObject2(), function (props) {
  return props.theme.idleIconFx;
}, function (props) {
  return props.theme.hoverIconFx;
}, function (props) {
  return props.theme.activeIconFx;
});
var disabled = (0, _styledComponents.css)(_templateObject3(), function (props) {
  return props.theme.disabledIconFx;
});

var Wrapper = _styledComponents["default"].div(_templateObject4(), function (props) {
  return base(props);
}, function (props) {
  return props.disabled ? disabled : {};
}, function (props) {
  return !props.disabled && props.ripple ? ripple : {};
}, function (props) {
  return !props.disabled && props.iconFx ? fx : {};
});

exports.Wrapper = Wrapper;
var _default = Wrapper;
exports["default"] = _default;